// filepath: apps/web/src/features/directory/person-summary/PersonSummaryRoute.tsx
//
// FR-UI-DIR-1 AC-2 — route shell for /people/:personId.
//
// The :personId path segment is extracted by AuthStateRouter and
// passed as a prop (see App.tsx where `<PersonSummaryRoute
// personId={...} />` is mounted).

import React from "react";
import { PersonSummaryPage } from "./PersonSummaryPage";

export interface PersonSummaryRouteProps {
  personId: string;
}

export function PersonSummaryRoute({
  personId,
}: PersonSummaryRouteProps): React.ReactElement {
  return <PersonSummaryPage personId={personId} />;
}
